import { render } from "./LiveBtnIcon.vue?vue&type=template&id=18047834"
import script from "./LiveBtnIcon.vue?vue&type=script&lang=js"
export * from "./LiveBtnIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__